import React from 'react';
import { LabelLarge } from '@ui-library/typography';
import { isValidationLoadingType } from '@components/sources/source/addSource';
import { Skeleton } from 'antd';
import DocLinkLabel from '@components/sources/docLinksLabel';
import { get } from 'lodash';
import StepValidateSource from './stepValidateSource';
import { warehouseList } from '../warehouseSourceList/warehouseSettings';
import classes from '../common.module.scss';
import { useSchemaValidation } from './hooks';

export type ValidateAccountInfoProps = {
  options?: Record<string, unknown>;
  secret?: Record<string, unknown>;
};
interface ISchemaValidation {
  status: isValidationLoadingType;
  checkValid: (val: isValidationLoadingType) => void;
  accountId?: string;
  sName: string;
  sourceDisplayName: string;
  accountInfo?: ValidateAccountInfoProps;
}

const SchemaValidation = (props: ISchemaValidation) => {
  const { status, checkValid, sName, accountId, accountInfo, sourceDisplayName } = props;
  const { validationStatus, checksInValidation, stepStatus } = useSchemaValidation(
    checkValid,
    status,
    sName,
    accountId,
    accountInfo,
  );

  const resultValidationTemplate = () => (
    <>
      {checksInValidation.map((item, key) => (
        <StepValidateSource
          stepInfo={item}
          key={key}
          status={
            validationStatus === isValidationLoadingType.hide ? validationStatus : stepStatus[key]
          }
        />
      ))}
    </>
  );

  const loadingValidationTemplate = () => <Skeleton active />;
  const verifyingCredentialsLink = get(warehouseList, sName.toUpperCase(), [{}])[0]?.docLinks
    ?.verifyingCredentials;
  return validationStatus !== isValidationLoadingType.hide ? (
    <>
      <LabelLarge className={classes.verify_creds_wrapper} data-testid="verifying_credentials">
        Verifying Credentials
      </LabelLarge>

      <DocLinkLabel
        description={`To know more about the validations below please 
                    refer to the ${sourceDisplayName} FAQs section`}
        linkRef={verifyingCredentialsLink}
      />
      {checksInValidation?.length || validationStatus === isValidationLoadingType.notStarted
        ? resultValidationTemplate()
        : loadingValidationTemplate()}
    </>
  ) : (
    <> </>
  );
};

export default SchemaValidation;
